var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"space"}},[_c('div',{attrs:{"id":"cont"}}),_c('div',{staticClass:"infoBox"},[_vm._v(" "+_vm._s(_vm.nowClickBuilding.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }